module.exports = __webpack_public_path__ + "img/zip.ea677dc9.svg";